(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.register', {
                url: '/register?{return-to}',
                templateUrl: 'app/components/register/register.view.html',
                controller: 'RegisterController',
                controllerAs: 'vm'
            })
            .state('accountManagement.registrationLanding', {
                url: '/registration-landing',
                templateUrl: 'app/components/register/registrationLanding.view.html'
            });
    }
})();
